/** Sincroniza a aba do Klinvia quando a receita Memed é salva em outra aba. */

export type MemedWorkspaceSavedEvent = {
  type: 'memed_prescription_saved';
  patientId: string;
  prescription: any;
  reprinted: boolean;
};

const CHANNEL_NAME = 'klinvia-memed-workspace';

export function notifyMemedPrescriptionSaved(payload: Omit<MemedWorkspaceSavedEvent, 'type'>) {
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage({ type: 'memed_prescription_saved', ...payload } satisfies MemedWorkspaceSavedEvent);
    channel.close();
  } catch {
    // BroadcastChannel indisponível — a aba principal atualiza ao voltar o foco.
  }
}

export function subscribeMemedPrescriptionSaved(
  handler: (event: MemedWorkspaceSavedEvent) => void,
): () => void {
  if (typeof BroadcastChannel === 'undefined') return () => undefined;
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.onmessage = (message) => {
    const data = message.data as MemedWorkspaceSavedEvent;
    if (data?.type === 'memed_prescription_saved') handler(data);
  };
  return () => channel.close();
}
